// Globals
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

// Modules
import { LLMTemplateResetConfirmModal } from '@/modules/LLMTemplateCommon';

// Store
import { useAppDispatch, useAppState } from '@/store';
import { resetChannelLLMTemplate, selectChannelLLMTemplateIsLoading } from '../../feature';

// Components
import { showSuccessToast } from '@/components';

type TLLMChannelTemplateResetModalProps = {
  channelId: number;
  isOpen: boolean;
  onClose: () => void;
};

const LLMChannelTemplateResetModal: FC<TLLMChannelTemplateResetModalProps> = ({ channelId, isOpen, onClose }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const isLoading = useAppState(selectChannelLLMTemplateIsLoading);

  const handleConfirm = async () => {
    try {
      await dispatch(resetChannelLLMTemplate({ channelId })).unwrap();
      onClose();
      showSuccessToast({ message: t('reset_llm_channel_template_success') });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <LLMTemplateResetConfirmModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handleConfirm}
      isLoading={isLoading}
      title={t('reset_llm_channel_template_title')}
      description={t('reset_llm_channel_template_description')}
    />
  );
};

export default LLMChannelTemplateResetModal;
